var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"rootRef",style:(_vm.rootStyle)},[_c('div',{staticClass:"v-sticky",class:{
        'v-sticky--fixed': _vm.state.fixed,
    },style:(_vm.stickyStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }